import(/* webpackMode: "eager" */ "/vercel/path0/apps/parrot/app/global-error.tsx");
